import React from 'react';

const Pptx = () => {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="32"
      viewBox="0 0 30 32"
    >
      <title>pptx</title>
      <path
        fill="#949494"
        d="M23 0l7 7v25h-25v-5.693l1 0.161v4.532h23v-23h-7v-7h-16v8.532l-1 0.161v-9.693h18zM26.5 26v1h-11v-1h11zM26.5 23.5v1h-11v-1h11zM17.5 5v7.5h7.5c0 4.142-3.358 7.5-7.5 7.5s-7.111-3.841-7.111-7.983c0-4.142 2.969-7.017 7.111-7.017zM23 1.5v5.5h5.5l-5.5-5.5z"
      ></path>
      <path
        fill="#b7472a"
        d="M15.5 8v20l-15.5-2.5v-15l15.5-2.5zM7.638 13.5h-3.138v9h2.003v-3.1h0.955c1.075 0 1.934-0.279 2.577-0.838s0.965-1.29 0.965-2.194c0-1.912-1.121-2.868-3.362-2.868zM7.291 15.056c1.067 0 1.6 0.462 1.6 1.387 0 0.906-0.49 1.378-1.47 1.416l-0.131 0.002h-0.788v-2.805h0.788zM18.5 5c1.508 0 2.471 0.423 3.5 1.118v1.882h1.891c0.701 0.919 1.109 1.992 1.109 3.5h-6.5v-6.5z"
      ></path>
    </svg>
  );
};

export default Pptx;
